"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusCodeForError = exports.AlreadyExistsError = exports.ForbiddenError = exports.ClientError = exports.UnauthorizedError = exports.DatabaseError = exports.ServiceError = exports.NotFoundError = exports.GenericError = void 0;
// TODO: Move all this to the shared lib whenever it's available.
class GenericError extends Error {
    innerError;
    payload;
    constructor(message, innerError, payload) {
        super(message);
        this.innerError = innerError;
        this.payload = payload;
        // Capture stack trace if available (Node.js environment)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GenericError);
        }
    }
}
exports.GenericError = GenericError;
class NotFoundError extends GenericError {
    entityName;
    entityValue;
    constructor(entityName, entityValue, innerError, payload) {
        super(`Value ${entityValue} not found in ${entityName}`, innerError, payload);
        this.entityName = entityName;
        this.entityValue = entityValue;
    }
}
exports.NotFoundError = NotFoundError;
class ServiceError extends GenericError {
    context;
    constructor(context, innerError, payload) {
        super(`Service Error: ${context}`, innerError, payload);
        this.context = context;
    }
}
exports.ServiceError = ServiceError;
class DatabaseError extends GenericError {
}
exports.DatabaseError = DatabaseError;
class UnauthorizedError extends GenericError {
}
exports.UnauthorizedError = UnauthorizedError;
class ClientError extends GenericError {
}
exports.ClientError = ClientError;
class ForbiddenError extends GenericError {
}
exports.ForbiddenError = ForbiddenError;
class AlreadyExistsError extends GenericError {
    constructor(message) {
        super(message);
    }
}
exports.AlreadyExistsError = AlreadyExistsError;
const getStatusCodeForError = (error) => {
    const errorStatusCodes = [
        [ClientError, 400],
        [UnauthorizedError, 401],
        [ForbiddenError, 403],
        [NotFoundError, 404],
        [AlreadyExistsError, 409],
        [GenericError, 500],
        // [IntegrationError, 504],
    ];
    for (const tuple of errorStatusCodes) {
        const [type, code] = tuple;
        if (error instanceof type) {
            return code;
        }
    }
    return 500;
};
exports.getStatusCodeForError = getStatusCodeForError;
//# sourceMappingURL=errors.js.map